import React from 'react';
import PropTypes from 'prop-types';

import { withModel } from '../../data-providers/model';

// TODO: Deprecate this implementation of the blog
//  it's not secure, and should not be used like this
//  good thing that this is actually happening now and this file
//  will be gone soon enough (2019-05-15)
const Blog = props => (
  <div
    dangerouslySetInnerHTML={{
      // THIS IS THE ONLY PLACE WE ALLOW UN-SANITIZED HTML
      // NEVER EVER EVER DO THIS SOMEWHERE ELSE
      __html: props.model.prismicPageModel.body
    }}
  />
);

Blog.propTypes = {
  model: PropTypes.shape({
    prismicPageModel: PropTypes.shape({
      body: PropTypes.string.isRequired
    }).isRequired
  }).isRequired
};

export default withModel(Blog);



// WEBPACK FOOTER //
// ./src/client/js/view/routes/Blog/Blog.js